import { Section } from '@lib/common';
import React from 'react';
import { InvoiceGroupingComponent } from './invoice-grouping-component';
import { CorporateAccount } from '@lib/state';
import { CorporateAccountInvoiceSettingsForm } from './corporate-account-invoice-settings-form';

interface Props {
  account: CorporateAccount;
}

export function CorporateAccountInvoiceSettings({ account }: Props) {
  return (
    <Section title="Invoice Settings" textAlign="left">
      <CorporateAccountInvoiceSettingsForm corporateAccount={account} />
      <InvoiceGroupingComponent account={account} />
    </Section>
  );
}
